export default "__VITE_ASSET__Fhl5ePhf__"